module.exports = __webpack_public_path__ + "assets/img/prize_4.107c4187.png";